import { StyleSheet } from 'react-native'
import { Theme } from '@theme'

export const getConversationHeaderStyles = (theme: Theme) =>
  StyleSheet.create({
    headerContainer: {
      backgroundColor: theme.colors.white,
      paddingHorizontal: 16,
      paddingBottom: theme.spacing.md,
    },
    
    // Première ligne : bouton retour + input + icône droite
    topRow: {
      flexDirection: 'row',
      alignItems: 'center',
      marginBottom: theme.spacing.md,
    },
    
    // Conteneur pour l'input de recherche
    inputContainer: {
      flex: 1,
      marginHorizontal: 8,
    },
    
    rightButton: {
      padding: 4,
      marginLeft: 12,
    },
    
    // Conteneur pour les tags (deuxième ligne)
    tagsContainer: {
      marginTop: 12,
    },
    
    tagsWrapper: {
      flexDirection: 'row',
      flexWrap: 'wrap',
      gap: 6,
    },
    
    tagsList: {
      paddingVertical: 2,
    },
    
    tagSeparator: {
      width: 6,
    },
    
    // Styles pour le tag du contact sélectionné - design selon l'image
    selectedContactTag: {
      flexDirection: 'row',
      alignItems: 'center',
      backgroundColor: '#E3F2FD', // Bleu très clair comme dans l'image
      borderRadius: 15,
      paddingHorizontal: 10,
      paddingVertical: 4,
      borderWidth: 1,
      borderColor: '#BBDEFB', // Bordure bleu clair
      width: '30%', // 3 tags par ligne (30% x 3 = 90% + gaps)
      maxWidth: 100,
    },
    
    tagAvatar: {
      width: 20,
      height: 20,
      borderRadius: 10,
      marginRight: 8,
    },
    
    tagName: {
      fontSize: 12,
      color: '#1976D2', // Bleu plus foncé pour le texte comme dans l'image
      fontWeight: '400',
      marginRight: 4,
      flex: 1,
    },
    
    removeButton: {
      padding: 1,
    },
  }) 